import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, FundAccountDialogueHandler } from './types';
import FundAccountDialogueContext from './FundAccountContext';

const { ConfirmationDialogue } = vp;

type FundAccountDialogueProps = {
  handleDialogue: DialogueHandler<FundAccountDialogueHandler>;
};

type FC = FunctionComponent<FundAccountDialogueProps>;

const FundAccountDialogue: FC = ({ handleDialogue }: FundAccountDialogueProps) => {
  const { showFundAccountErrorAlert, fundAccountError } = useContext(FundAccountDialogueContext);

  return useMemo(
    () => (
      <div>
        {/* EFT Fund Error */}
        <ConfirmationDialogue
          isVisible={showFundAccountErrorAlert}
          title="Error"
          status="error"
          subTitle={`${fundAccountError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showFundAccountErrorAlert, fundAccountError],
  );
};

export default FundAccountDialogue;
